<template>
  <div class="row bg-white border-bottom course-row">
    <div class="col-6">
      <div :id="area.id" class="d-flex flex-column justify-content-center h-100 area-title-wrapper">
        <div>
          <h1 class="title">{{ area.intake }}</h1>
          <!-- <h3 v-if="area.titleDetail" class="title-detail">{{ area.titleDetail }}</h3> -->
          <!-- <h2 class="subtitle" v-html="area.subtitle"></h2>
           -->
          <!-- <h2 v-if="area.fromMonth && area.toMonth && area.fromMonth !== area.toMonth" class="subtitle">
            <span class="text-cus-secondary">WEEKEND INTAKE</span> -
            <span class="text-cus-primary">{{ area.fromMonth }} & {{ area.toMonth }}</span>
          </h2>
          <h2 v-else class="subtitle">
            <span class="text-cus-secondary">WEEKEND INTAKE</span> -
            <span class="text-cus-primary">{{ area.fromMonth ?? area.toMonth }}</span>
          </h2> -->
          <template v-if="fixedIntake">
            <h2 class="subtitle">
              <span class="text-cus-secondary">WEEKEND INTAKE</span> -
              <span class="text-cus-primary">July</span>
            </h2>
            <h2 class="subtitle">
              <span class="text-cus-secondary">SUMMER INTAKE</span> -
              <span class="text-cus-primary"> April</span>
            </h2>
          </template>
          <template v-else>
            <h2 v-if="area.fromMonth && area.toMonth && area.fromMonth !== area.toMonth" class="subtitle">
              <span class="text-cus-secondary">INTAKE</span> -
              <span class="text-cus-primary">{{ area.fromMonth }} to {{ area.toMonth }}</span>
            </h2>
            <h2 v-else class="subtitle">
              <span class="text-cus-secondary">INTAKE</span> -
              <span class="text-cus-primary">{{ area.fromMonth ?? area.toMonth }}</span>
            </h2>
          </template>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="course d-flex flex-column justify-content-center h-100">
        <AreaItem v-for="(item, index) in area.curriculum" :data="item" :index="index" :key="index"></AreaItem>
      </div>
    </div>
  </div>
</template>

<script>
import AreaItem from "@/components/Academic/AreaItem.vue";
export default {
  components: {
    AreaItem,
  },
  props: {
    area: Object,
    fixedIntake: {
      default: false,
    }
  }
};
</script>

<style lang="scss" scoped>
.area-title-wrapper {
  margin-left: 15%;
}

.title {
  display: inline-block;
  text-transform: uppercase;
  font-weight: var(--cus-fw-semibold);
  color: var(--cus-primary);
  font-size: var(--cus-fs-xxxx-large);
  margin-right: 5px;
  width: 100%;
  word-wrap: break-word;
}

.title-detail {
  text-transform: uppercase;
  display: inline-block;
  font-weight: var(--cus-fw-semibold);
  color: var(--cus-primary);
  font-size: var(--cus-fs-xx-large);
}

.subtitle {
  text-transform: uppercase;
  font-weight: var(--cus-fw-semibold);
  color: var(--cus-primary);
  font-size: var(--cus-fs-x-large);
}

.course {
  padding: 20px 0;
}

.course-row {
  min-height: 200px;
}
</style>
